import { TaskListDialog } from 'cadenza/task-list-dialog/task-list-dialog';

/**
 * Shows and returns a loading dialog for saving a workbook.
 *
 * @return loadingMessageDialog
 */
export function createAndConnectLoadingDialog() {
  const loadingMessageDialog = new TaskListDialog();
  loadingMessageDialog.connectAndShow();
  return loadingMessageDialog;
}
